import React from 'react';
import classNames from 'classnames';

const ChowaNoInlineCard = ({ children, className, style }) => {
  return (
    <div 
      className={classNames(
        'bg-white dark:bg-gray-800 rounded-lg', // カードの中身：テーマの基本色、枠線なし
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};

export default ChowaNoInlineCard; 